'use client';
import { ComponentType } from 'react';
import { HeightSinceWidth } from '../placeholder/placeholder.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './paragraph.component';
import dynamic from 'next/dynamic';

const DynamicParagraphComponent: ComponentType<Props> = dynamic(
  () => import('./paragraph.component')
);

export default DynamicParagraphComponent;

export function calculateParagraphPlaceholderConfig(props: Props): PlaceholderConfig {
  const contentHtmlLength: number = props.contentHtml.length;
  const collapsable: boolean = props.collapsable;

  let heightSinceWidth: HeightSinceWidth = [
    { sinceWidth: 0, height: contentHtmlLength / 56 + 48 },
    { sinceWidth: 768, height: contentHtmlLength / 60 + 48 },
    { sinceWidth: 1024, height: contentHtmlLength / 117 + 48 },
    { sinceWidth: 1440, height: contentHtmlLength / 164 + 48 }
  ];
  // contentHtmlLength is divided by the number of characters that fit in a line
  // then the height of the readMore button is added.

  if (contentHtmlLength !== 0) {
    if (collapsable) {
      heightSinceWidth = heightSinceWidth.map((element) => {
        return {
          sinceWidth: element.sinceWidth,
          height: 625
        };
      });
    }
  } else {
    heightSinceWidth = [{ sinceWidth: 0, height: 0 }];
  }

  return {
    heightSinceWidth
  };
}
